import React from 'react';
import {Grid,Divider} from '@material-ui/core'
import {useSelector, useDispatch} from 'react-redux'
import {isEmpty} from 'lodash'
import CheckBoxInput from '../Inputs/CheckBoxInput'
import CheckBoxInputAnsvarig from '../Inputs/CheckBoxInputAnsvarig/index'
import CheckBoxInputType from '../Inputs/CheckBoxInputType'
import CheckBoxInputTaggning from '../Inputs/CheckBoxInputTaggning'
import CheckBoxInputDistrikt from '../Inputs/CheckBoxInputDistrikt'
import CheckBoxInputUtokning from '../Inputs/CheckBoxInputUtokning'
import CheckBoxDatum from '../Inputs/CheckBoxDatum'
import CheckBoxKundStatus from '../Inputs/CheckBoxKundStatus'
import CheckBoxInputOrt from '../Inputs/CheckBoxInputOrt'
function KundSection(props) {
    const CurrentObjekt = useSelector(state => state.accountsData.CurrentObjekt)
    const Flags = useSelector(state => state.accountsData.Flags) 
    const onChangeMstate=(Chips)=>{
        console.log(Chips)
    }
    return (<>
           <Grid container direction="row" alignItems="center" className='mt-2 pt-2 pl-2' style={{maxHeight:460,minHeight:120,overflowY:"auto"}}>
           <Grid item style={{height:46}} className={"pt-1"} xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Kundnr" MetaN={"Kund_KundNr"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="KundId" MetaN={"Kund_KundId"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Kundnamn" MetaN={"Kund_KundNamn"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Kund orgnr" MetaN={"Kund_KundOrgnr"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>

           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Divisionsnamn" MetaN={"Kund_Divisionsnamn"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Senaste aktivitet" MetaN={"Kund_SenasteAktivitet"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={12} md={3} lg={2} >
           <CheckBoxInputType Meta="Kundtyp" MetaN={"Kund_Kundtyp"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxKundStatus Meta="Status" MetaN={"Kund_Status"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           {
            parseInt(Flags.Distrikt) === 1?
            <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
            <CheckBoxInputDistrikt Meta="Distrikt" MetaN={"Kund_Distrikt"} disabled={false} Value={true} 
            onChangeMstate={props.onChangeMstate} 
            Mstate={props.Chips}
            />
            </Grid>
            :""
           }
        <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputAnsvarig Meta="Skapad av" MetaN={"Kund_Huvudansvarig"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputAnsvarig Meta="Ansvarig" MetaN={"Kund_Ansvarig"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Ansvarig Kontor" MetaN={"Kund_AnsvarigKontor"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Ansvarig E-post" MetaN={"Kund_AnsvarigEpost"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Ansvarig Telefon" MetaN={"Kund_AnsvarigTelefon"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="Skapad" MetaN={"Kund_Skapad"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
          
           <Grid item className={"p-2"}  xs={12} >
            <Divider/>
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Kund epost" MetaN={"Kund_Epost"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Telefon" MetaN={"Kund_Tele"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Extra Telefon" MetaN={"Kund_ExtraTele"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Hemsida" MetaN={"Kund_webSite"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>

           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Adress" MetaN={"Kund_Adress"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Extra adress" MetaN={"Kund_ExtraAdress"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputOrt Meta="Ort" MetaN={"Kund_Ort"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  className={"p-2"}  xs={12} >
            <Divider/>
           </Grid>
            <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Leveransnamn" MetaN={"Kund_Deliveriesnamn"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="LeveransTele" MetaN={"Kund_DeliveriesTele"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Leveransadress" MetaN={"Kund_DeliveriesAdress"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  className={"p-2"} xs={12} >
            <Divider/>
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Fakturanamn" MetaN={"Kund_Fakturanamn"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="FakturaTele" MetaN={"Kund_FakturaTele"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="FakturaEpost" MetaN={"Kund_FakturaEpost"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Fakturaadress" MetaN={"Kund_Fakturaadress"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Extra Fakturaadress" MetaN={"Kund_ExtraFakturaadress"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>           
           <Grid item className={"p-2"}  xs={12} >
            <Divider/>
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputTaggning Meta="Taggning" MetaN={"Kund_Taggning"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputUtokning Meta="Fria fält" MetaN={"Kund_FriaFält"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           {
            props.Chips.some(item=>item.MetaN === "Kund_FriaFält")?
            isEmpty(CurrentObjekt)?"":
           <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Antal fria fält" MetaN={"Kund_FriaFält_Antal"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>:""
            }
           <Grid item className={"p-2"}  xs={12} >
            <Divider/>
           </Grid>
           {
            props.Chips.some(item=>item.MetaN === "Kund_FriaFält")?
            isEmpty(CurrentObjekt)?"":
            CurrentObjekt.map(item=>{
                console.log(item)
                return <Grid item style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2}> 
                  <CheckBoxInput 
                  Meta={`Fria fält ${item.Meta}`} 
                  MetaN={`Kund_FriaFält_Parameter_${item.Meta}`}
                  disabled={false} 
                  Value={false} 
                  onChangeMstate={props.onChangeMstate} 
                  Mstate={props.Chips}/></Grid>
             
          }):""
           }
           </Grid>
          
           
        </>
    );
}

export default KundSection;